import { FC } from 'react'

import {
  Text,
  IconExclamationTriangle,
  Button,
  GreyGrey80,
  Primary12Regular,
  Flex
} from '@sequencehq/core-components'
import { CountPill } from './CountPill'

export const Trigger: FC<{ errorCount: number; warningCount: number }> = ({
  errorCount,
  warningCount
}) => {
  return (
    <Button
      variant="secondary"
      data-testid="automations.editor.workflowErrors.trigger"
    >
      <Flex gap="8px" alignItems="center">
        <IconExclamationTriangle color={GreyGrey80} />

        {errorCount > 0 && (
          <Flex gap="8px" alignItems="center">
            <Text {...Primary12Regular} color={GreyGrey80}>
              Errors
            </Text>
            <CountPill count={errorCount} level="ERROR" />
          </Flex>
        )}

        {warningCount > 0 && (
          <Flex gap="8px" alignItems="center">
            <Text {...Primary12Regular} color={GreyGrey80}>
              Warnings
            </Text>
            <CountPill count={warningCount} level="WARN" />
          </Flex>
        )}
      </Flex>
    </Button>
  )
}
